import Typography from './typography';
export type { TypographyProps } from './typography.types';

export default Typography;
